<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <div class="col-sm-12">
          <button type="button" class="btn btn-block btn-primary" @click="toggleAutoFetch">{{ autoFetchButtonText }}
          </button>
        </div>
      </div>
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title1')" class="col-sm-4 col-form-label">Team 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title1')" v-model.lazy="title1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title2')" class="col-sm-4 col-form-label">Team 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title2')" v-model.lazy="title2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('sets1')" class="col-sm-4 col-form-label">Sets 1</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('sets1')" v-model.lazy="sets1">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('sets1', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('sets1', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('sets2')" class="col-sm-4 col-form-label">Sets 2</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('sets2')" v-model.lazy="sets2">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('sets2', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('sets2', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('points1')" class="col-sm-4 col-form-label">Points 1</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('points1')" v-model.lazy="points1">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points1', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points1', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('points2')" class="col-sm-4 col-form-label">Points 2</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('points2')" v-model.lazy="points2">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points2', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points2', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('points2')" class="col-sm-6 col-form-label">Service</label>
        <div class="col-sm-2">
          <button class="btn btn-block"
                  :class="[service === '0' ? 'btn-primary' : 'btn-secondary']" @click="setService('0')">0
          </button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-block"
                  :class="[service === '1' ? 'btn-primary' : 'btn-secondary']" @click="setService('1')">1
          </button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-block"
                  :class="[service === '2' ? 'btn-primary' : 'btn-secondary']" @click="setService('2')">2
          </button>
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('federationCode')" class="col-sm-4 col-form-label">Federation code</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('federationCode')" v-model.lazy="federationCode">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('authToken')" class="col-sm-4 col-form-label">Authorization</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('authToken')" v-model.lazy="authToken">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('matchId')" class="col-sm-4 col-form-label">Match</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('matchId')" v-model.lazy="matchId">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('fetchIntervalMs')" class="col-sm-4 col-form-label">Fetch Interval (ms)</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('fetchIntervalMs')" v-model.lazy="fetchIntervalMs">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateOptions } from '../../utils/index'
  import * as action from '../../store/action-types'
  import VolleyballApi from '../../api/VolleyballApi'

  const DEFAULT_FETCH_INTERVAL_MS = 5000

  export default {
    name: 'volleyball-scoreboard',
    mixins: [templateMixin],
    data: function () {
      return {
        autoFetch: false,
        errorMessage: null
      }
    },
    computed: {
      ...mapOverlayData(['title1', 'title2', 'sets1', 'sets2', 'points1', 'points2', 'service']),
      ...mapTemplateOptions(['federationCode', 'authToken', 'matchId']),
      ...mapTemplateOptions({fetchIntervalMs: {default: DEFAULT_FETCH_INTERVAL_MS}}),
      autoFetchButtonText () {
        return this.autoFetch ? 'Stop Fetching' : 'Start Fetching'
      }
    },
    created: function () {
      this.api = new VolleyballApi(this.$env)
    },
    methods: {
      add (id, value) {
        this[id] = '' + ((parseInt(this[id]) || 0) + value)
        const data = {}
        data[id] = this[id]
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data
        })
      },
      setService (value) {
        this.service = value
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data: {'service': value}
        })
      },
      toggleAutoFetch () {
        this.autoFetch = !this.autoFetch
        this.errorMessage = null
        if (this.autoFetch && !this.timeoutId) {
          this.fetchData()
        } else if (!this.autoFetch && this.timeoutId) {
          window.clearTimeout(this.timeoutId)
          this.timeoutId = null
        }
      },
      fetchData () {
        this.errorMessage = null
        this.getApi().getMatchFullInfo(this.matchId)
          .then(response => {
            this.updateData(response)
            this.scheduleFetch()
          })
          .catch(error => {
            this.autoFetch = false
            this.errorMessage = error.message || error
          })
      },
      getApi () {
        return this.api
          .setFederationCode(this.federationCode)
          .setAuthToken(this.authToken)
      },
      updateData ({data}) {
        this.title1 = this.title1 || ('' + data.HTN)
        this.title2 = this.title2 || ('' + data.GTN)
        this.sets1 = '' + data.WSH
        this.sets2 = '' + data.WSG
        this.points1 = '' + data.CHP
        this.points2 = '' + data.CGP
        if (data.CR) {
          this.service = data.CR.WinHG ? '1' : '2'
        } else {
          this.service = '0'
        }
        this.$store.dispatch(action.COMMAND_UPDATE, {
          templateId: this.templateId, channelId: 'program'
        })
        this.$store.dispatch(action.COMMAND_UPDATE, {
          templateId: this.templateId, channelId: 'preview'
        })
      },
      scheduleFetch () {
        if (this.timeoutId) {
          window.clearTimeout(this.timeoutId)
          this.timeoutId = null
        }
        this.timeoutId = window.setTimeout(this.fetchData.bind(this), this.fetchIntervalMs || DEFAULT_FETCH_INTERVAL_MS)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/volleyball-scoreboard.vue